import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components/macro'
import { AnimatePresence, motion } from 'framer-motion'
import { QuestionTransitions } from '../../../../style/transitions'
import Button from '../../../common/Button'
import theme from '../../../../style/theme'
import { useAnalytics } from 'use-analytics'
import MasterPage from '../../../common/MasterPage'
import Container from '../../../common/Container'
import { rem } from 'polished'
import { ROUTES } from '../../../../constants'

const Suggestions = ({ board }) => {
  const { track } = useAnalytics()
  const { description, name, link, id } = board || {}

  return (
    <MasterPage isBold isResults caption="Your Results" heading={name}>
      <AnimatePresence exitBeforeEnter>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.35 }}
        >
          <ProcessContainer>
            <StyledMotion
              initial={QuestionTransitions.initial}
              animate={QuestionTransitions.animate}
              exit={QuestionTransitions.exit}
              transition={QuestionTransitions.transition(0.7, 0)}
            >
              <Wrapper>
                <AnimatePresence exitBeforeEnter>
                  <Description key={1}>{description}</Description>
                  <Image key={2} src={`/images/results/${id}.jpg`} />
                </AnimatePresence>
                <Center
                  initial={QuestionTransitions.initial}
                  animate={QuestionTransitions.animate}
                  exit={QuestionTransitions.exit}
                  transition={QuestionTransitions.transition(0.2, 1.5)}
                >
                  <ConstrainedLink
                    rel="noopener noreferrer"
                    href={link}
                    target="_blank"
                    onClick={() => track('click_pinterest', {})}
                  >
                    <Button uppercase color="white">
                      Get ideas on pinterest
                    </Button>
                  </ConstrainedLink>
                </Center>
                <Center
                  initial={QuestionTransitions.initial}
                  animate={QuestionTransitions.animate}
                  exit={QuestionTransitions.exit}
                  transition={QuestionTransitions.transition(0.2, 1.5)}
                  second
                >
                  <ConstrainedLink
                    rel="noopener noreferrer"
                    href="https://www.marriott.com/loyalty/where-can-we-take-you.mi"
                    target="_blank"
                    onClick={() => track('click_more', {})}
                  >
                    <Button
                      uppercase
                      color={theme.color.questionText}
                      theme="white"
                    >
                      Discover More with Marriott Bonvoy
                    </Button>
                  </ConstrainedLink>
                </Center>
                <Center>
                  <Out
                    rel="noopener noreferrer"
                    href={ROUTES.HOME}
                    onClick={() => track('retake_quiz', {})}
                  >
                    Retake Quiz
                  </Out>
                </Center>
              </Wrapper>
            </StyledMotion>
          </ProcessContainer>
        </motion.div>
      </AnimatePresence>
    </MasterPage>
  )
}

Suggestions.propTypes = {
  board: PropTypes.object,
}

export default Suggestions

const ConstrainedLink = styled.a``
const Center = styled(motion.div)`
  ${({ second }) => css`
    display: flex;
    justify-content: center;
    margin: 2em 0 0;
    padding-bottom: 0;
    ${second &&
      css`
        margin-top: 1em;
      `}

    ${theme.media.md`
      margin: ${second ? '1em auto 2em' : '1em auto 1em'};
      padding-bottom: 0;
      max-width: 436px;
      width: 100%;
    `}
    ${theme.media.lg`
      width: 100%;
      max-width: 530px;
    `}
    a {
      width: 100%;

      button {
        width: 100%;
      }
    }
  `}
`
const Out = styled.a`
  ${({ theme }) => css`
    font-size: 0.9375em;
    margin-bottom: 2em;
    text-decoration: underline;
    text-align: center;
    &:hover {
      text-decoration: underline;
    }
    ${theme.media.lg`
      font-size: 1.375em;
      margin-bottom: 0;
    `}
  `}
`
const Description = styled.div`
  ${({ theme }) => css`
    max-width: 675px;
    margin: 0 auto;
    padding: 0 1em;
    font-size: ${rem(18)};
    line-height: 133%;
    text-align: center;
    ${theme.media.lg`   
    `}
  `}
`
const Image = styled.img`
  ${({ theme }) => css`
    margin: 1em auto 2em;
    display: flex;
    max-width: 100%;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
  `}
`

const Wrapper = styled.div`
  ${({ theme }) => css`
    max-width: 90%;
    margin: 0 auto;
    ${theme.media.md`
      max-width: auto;
      margin: auto;
    `}
  `}
`
const ProcessContainer = styled(Container)``
const StyledMotion = styled(motion.div)`
  position: relative;
`
